import { useContext } from 'react';

import { TaskDetailActionsContext } from './task-detail-context';

export const useCloseTaskDetail = () => {
  const { closeDetail } = useContext(TaskDetailActionsContext);

  return closeDetail;
};
